import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

import cartSlice from "./slices/cartSlice";
import profileReducer from "./slices/profileSlice";
import restaurantCartReducer from "./slices/restaurantCartSlice";
import updateCountSlice from "./slices/updateCountSlice";
import { restaurantSlice } from "./slices/restaurantSlice";
import impersonationReducer from "./slices/impersonationSlice";

const profilePersistConfig = {
  key: "userProfile",
  storage,
};

const impersonationPersistConfig = {
  key: "impersonation",
  storage,
};

const rootReducer = combineReducers({
  userCart: cartSlice,
  userProfile: persistReducer(profilePersistConfig, profileReducer),
  restaurantCart: restaurantCartReducer,
  updateCount: updateCountSlice,
  restaurant: restaurantSlice.reducer,
  impersonation: persistReducer(
    impersonationPersistConfig,
    impersonationReducer,
  ),
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
